import type { AriaAttributes, HTMLAttributes } from 'react';

type BaseProps = {
  orientation?: AriaAttributes['aria-orientation'];
};

export type Props = BaseProps &
  (
    | {
        label: string;
        labelId?: never;
      }
    | {
        label?: never;
        labelId: string;
      }
  );

export type Result = HTMLAttributes<HTMLElement>;

export const useTabList = ({
  label = undefined,
  labelId = undefined,
  orientation = `vertical`,
}: Props): Result => ({
  role: `tablist`,
  'aria-label': label,
  'aria-labelledby': labelId,
  'aria-orientation': orientation,
});
